var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[(_vm.loading)?_c('van-loading',{attrs:{"size":50,"type":"circular","color":"rgb(100, 100, 100)"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }